import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { POCreditMemoDetails } from '../types/POCreditMemoDetails';

export const useGetCreditMemo = (creditMemoID?: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        enabled: !!creditMemoID,
        queryKey: ['credit-memo', creditMemoID],
        queryFn: async () => await apiClient.get('purchase-order/credit-memo',
            {
                params: {
                    creditMemoID: creditMemoID
                }
            }) as POCreditMemoDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
